var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.state.app)?_c('div',{staticClass:"container-create-order"},[_c('div',{staticClass:"list-carrito"},[_c('ItemsListOrders'),_c('CartOrders')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }